import { useCallback } from 'react';
import { useDisconnect } from 'wagmi';
import { useDispatch } from 'react-redux';
import { logoutAction } from '~/store/actions/user-state-actions';

export const useLogout = () => {
  const { disconnect } = useDisconnect();
  const dispatch = useDispatch();
  const logout = useCallback(async () => {
    disconnect();
    await dispatch(logoutAction());
  }, [disconnect, dispatch]);

  return logout;
};
